import { localStorage } from "@/utils/localStorage";
import router from "../../router";
import { clearBrowserData } from "@/utils/common";

const SET_APP_DATA = "SET_APP_DATA";
const SET_CURR_PERMISSION = "SET_CURR_PERMISSION";
const LOGOUT_ACTION = "LOGOUT_ACTION";

const initState = () => {
  return {
    token: "",
    userName: "",
    cinemas: [],
    brandId: "",
    accountId: "",
    cinemaId: "",
    moduleMap: {},
    permissionMap: {},
    currentPermission: {},
    adminType: "",
    isAdmin: null,
    round: "",
    brandCode: "",
    cinemaObj: [],
    dictionary: {},
    loginAsAccountId: "",
    originalUserMsg: {},
    accountDetailInfo: {},
  };
};

export default {
  namespaced: true,
  state: initState(),
  getters: {
    isSuperAdmin(state) {
      return state.adminType && state.adminType === "superAdmin";
    },
    getModulePermission: state => moduleName => {
      const { permissionMap } = state;
      let permissions = [];
      let targetObj = {};
      Object.keys(permissionMap).forEach(key => {
        if (permissionMap[key].module === moduleName) {
          permissions = permissionMap[key].types;
          return;
        }
      });

      permissions.forEach(_p => {
        targetObj[_p] = true;
      });

      return targetObj;
    },
    getCurrentPermission: state => {
      return state.currentPermission;
    },
    allAppStates: state => {
      const resultObj = {};
      Object.keys(state).forEach(key => {
        resultObj[key] = state[key];
      });

      return resultObj;
    },
  },
  mutations:{
    [SET_APP_DATA](state, payload) {
      if (typeof payload === undefined || typeof payload.data === undefined) { return; }

      const {
        data,
        isLogin = false,
        isSupplement = false,
        vuexOnly,
      } = payload;

      Object.keys(data).forEach(key => {
        state[key] = data[key];
        if (!vuexOnly) {
          localStorage.set(key, data[key]);
        }
      });

      if (isLogin) {
        state.originalUserMsg = payload.data;
        localStorage.set("originalUserMsg", payload.data);
      }

      if (isSupplement) {
        let existOriginalUserMsg = { ...state.originalUserMsg };
        Object.keys(data).forEach(key => {
          state.originalUserMsg[key] = data[key];
          existOriginalUserMsg[key] = data[key];
        });
        localStorage.set("originalUserMsg", existOriginalUserMsg);
      }
    },
    [SET_CURR_PERMISSION](state, payload) {
      /** set current page user permission */
      state.currentPermission = payload;
      localStorage.set("currentPermission", payload);
    },
    [LOGOUT_ACTION](state, payload) {
      Object.keys(state).forEach(key => {
        state[key] = payload[key];
      });

      clearBrowserData();
      router.push("/login");
    },
  },
  actions: {
    setAppData({ commit }, payload) {
      commit(SET_APP_DATA, payload);
    },
    setCurrentPermission({ commit }, payload) {
      commit(SET_CURR_PERMISSION, payload);
    },
    logoutAction({ commit }) {
      const state = initState();
      commit(LOGOUT_ACTION, state);
    },
  }
};
